import React from "react";
import SubPageShell from "@/apps/rider/components/SubPageShell";

export default function TermsOfService() {
  return (
    <SubPageShell
      eyebrow="Legal"
      title="Terms of service"
      subtitle="The rules of the road for riding with Link."
      back="/account"
      backLabel="Account"
      testId="terms-page"
    >
      <article className="prose prose-sm sm:prose-base max-w-none text-[#0A1128]" data-testid="terms-content">
        <p className="text-[#515E7B]">Last updated: February 2026</p>

        <h2 className="font-serif text-xl mt-6">What Link is</h2>
        <p>
          Link is a pre-scheduled, recurring round-trip transportation service.
          You set a route, we run it. We are not a rideshare app, a courier, or
          an on-demand taxi; we don't accept stops outside your booked route.
        </p>

        <h2 className="font-serif text-xl mt-6">Booking</h2>
        <p>
          When you confirm a route, you authorize the charge displayed on the
          confirmation surface — either a one-time charge or a recurring weekly
          subscription. Subscriptions auto-renew on Mondays at 6 AM Central until
          you cancel.
        </p>

        <h2 className="font-serif text-xl mt-6">Cancellations and refunds</h2>
        <p>
          You may cancel a single upcoming trip up to three hours before pickup
          with no charge. Subscription cancellations take effect at the end of
          the current paid week — already-paid weeks remain bookable.
        </p>
        <p>
          If we miss a scheduled pickup window by more than 30 minutes, that
          ride is refunded automatically. For other refund situations, contact
          support and we'll review case-by-case.
        </p>

        <h2 className="font-serif text-xl mt-6">Behavior on rides</h2>
        <p>
          Riders must wear seatbelts, refrain from smoking, and treat drivers
          with respect. Repeated complaints from drivers may result in account
          suspension at our discretion.
        </p>

        <h2 className="font-serif text-xl mt-6">Liability</h2>
        <p>
          Link operates as a transportation network. Drivers carry their own
          commercial insurance plus our supplemental coverage during active
          rides. Our maximum liability for service interruption is the value
          of the ride(s) affected.
        </p>

        <h2 className="font-serif text-xl mt-6">Termination</h2>
        <p>
          You may close your account anytime by emailing support. We reserve the
          right to suspend accounts for fraudulent activity, repeated payment
          failure, or any breach of these terms.
        </p>

        <h2 className="font-serif text-xl mt-6">Contact</h2>
        <p>
          Questions on these terms? <a className="text-[#ed6500]" href="mailto:lamar@lefcoholdings.com">lamar@lefcoholdings.com</a>
        </p>
      </article>
    </SubPageShell>
  );
}
